export default class Distribution {
    constructor (dto) {
        this.documents = []
        this.autoFinish = false
        this.notifyByEmail = false
        this.details = []

        if (dto) {
            this.documents = dto.map(x => parseInt(x))
        }
    }

    toDto () {
        return {
            ObjectIDs: this.documents,
            AutoFinish: this.autoFinish,
            NotifyByEmail: this.notifyByEmail,
            Details: this.details.map(x => x.toDto()),
        }
    }
}
